import { v4 as createUUID } from "uuid";

function getUniqueIdentifier() {
    return createUUID();
}

export default getUniqueIdentifier;